import React, { useState } from "react";

import makeStyles from "@material-ui/styles/makeStyles";

import { Markdown, type TMarkdownProps } from "lib/components/markdown";
import { formatMessage } from "lib/globalize-util";
import classnames from "classnames";

export type TCustomizationDescriptionProps = TMarkdownProps;

export const MORE_SEPARATOR = "`!@more@!`";

export const CustomizationDescription: React.FC<TCustomizationDescriptionProps> = ({
    children,
    className,
    ...props
}) => {
    const styles = useStyles();
    const [collapsed, setCollapsed] = useState(true);
    if (!children) {
        return null;
    }

    const [header, description = ""] = children.split(MORE_SEPARATOR);
    const hasReadmore = !!description;
    const text = `${header}${hasReadmore && collapsed ? "" : description}`;

    return (
        <div className={classnames(styles.container, className)}>
            <Markdown {...props}>{text}</Markdown>
            {!hasReadmore ? null : (
                <span className={styles.seeMore} onClick={() => setCollapsed((collapsed) => !collapsed)}>
                    {formatMessage(collapsed ? "See More" : "See Less")}
                </span>
            )}
        </div>
    );
};

const useStyles = makeStyles({
    container: {
        display: "flex",
        flexFlow: "column wrap",
    },
    seeMore: {
        textDecoration: "underline",
        cursor: "pointer",
        color: "#1e1e1e",
    },
});
